import { render, staticRenderFns } from "./NotificationsView.vue?vue&type=template&id=6b356457&scoped=true"
import script from "./NotificationsView.vue?vue&type=script&lang=ts"
export * from "./NotificationsView.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsView.vue?vue&type=style&index=0&id=6b356457&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b356457",
  null
  
)

export default component.exports